import { render, staticRenderFns } from "./DirectSearch.vue?vue&type=template&id=71afcf76&scoped=true&"
import script from "./DirectSearch.vue?vue&type=script&lang=js&"
export * from "./DirectSearch.vue?vue&type=script&lang=js&"
import style0 from "./DirectSearch.vue?vue&type=style&index=0&id=71afcf76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71afcf76",
  null
  
)

export default component.exports